import {z} from 'zod';
import dedent from 'dedent';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'edit-component-code' as const;

const argumentZod = z.object({
  componentId: z.string().describe('The ID of the code component to edit.'),
  instruction: z
    .string()
    .describe(
      'A single sentence instruction describing the edit. Use first person to describe what you are going to do and disambiguate any uncertainty.'
    ),
  update: z
    .string()
    .describe(
      'An abbreviated edit snippet showing only the changes, using comments like "// ... existing code ..." to denote unchanged sections. Preserve indentation and final code structure.'
    ),
});

export const editComponentCodeTool = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Edit component code',
  prettyErrors: {
    fallback: 'Unable to edit component code.',
    patterns: [
      {
        match: 'not found',
        message: 'Component not found.',
      },
      {
        match: 'compilation',
        message: 'Code failed to compile after edit.',
      },
    ],
  },
  llmTool: {
    name: toolName,
    description: dedent`
      Edits the code of a code component using a fast-apply model. The edit is specified via a brief instruction and an abbreviated update snippet that will be merged with the existing component code.

      Use this tool for small to medium edits to a code component's source code. For completely rewriting a component, prefer 'set-component-code'.

      The code will be compiled after the edit is applied. If compilation fails, the error will be returned but the edit will still be saved.
    `,
    inputSchema: argumentZod,
  },
  type: 'designer',
  permission: [{resource: 'SiteSymbol', action: 'modify'}],
  confirmBeforeExecuting: false,
  timeout: 60000,
});
